import { apiClient } from './apiClient';
import {
  ServiceRequest,
  CreateRequestPayload,
  PaginatedResponse,
  RequestState,
} from '../types';

export const requestService = {
  async create(payload: CreateRequestPayload): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>('/requests/', payload);
    return data;
  },

  async list(params?: {
    status?: RequestState;
    page?: number;
    search?: string;
  }): Promise<PaginatedResponse<ServiceRequest>> {
    const { data } = await apiClient.get<PaginatedResponse<ServiceRequest>>('/requests/', {
      params,
    });
    return data;
  },

  async listNearby(params: {
    latitude: number;
    longitude: number;
    radius_km?: number;
  }): Promise<PaginatedResponse<ServiceRequest>> {
    const { data } = await apiClient.get<PaginatedResponse<ServiceRequest>>('/requests/nearby/', {
      params,
    });
    return data;
  },

  async getDetail(id: string): Promise<ServiceRequest> {
    const { data } = await apiClient.get<ServiceRequest>(`/requests/${id}/`);
    return data;
  },

  async uploadAttachment(requestId: string, file: {
    uri: string;
    name: string;
    type: string;
  }): Promise<{ id: string; file_url: string }> {
    const formData = new FormData();
    formData.append('file', {
      uri: file.uri,
      name: file.name,
      type: file.type,
    } as any);

    const { data } = await apiClient.post(
      `/requests/${requestId}/attachments/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },

  // Admin actions
  async approve(id: string): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>(`/requests/${id}/approve/`);
    return data;
  },

  async reject(id: string, reason?: string): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>(`/requests/${id}/reject/`, { reason });
    return data;
  },

  async resubmit(id: string): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>(`/requests/${id}/resubmit/`);
    return data;
  },

  async assignSurveyor(requestId: string, surveyorId: string): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>(
      `/requests/${requestId}/assign/`,
      { surveyor_id: surveyorId },
    );
    return data;
  },

  async unassignSurveyor(requestId: string, reason?: string): Promise<ServiceRequest> {
    const { data } = await apiClient.post<ServiceRequest>(
      `/requests/${requestId}/unassign/`,
      { reason },
    );
    return data;
  },
};
